module.exports = __webpack_public_path__ + "img/ic_member_year.04ee170c.png";